export * from "./api";
export * from "./stores";
export * from "./FpId";
export * from "./MqttClient";
//export * from "./MediaApiDropHandler";

import * as _LIB_INSTANCES from "./instances";

/**
 * set once globally, will be reused by all instances of <FpProvider/>
 */
export const LIB_INSTANCES = _LIB_INSTANCES;



// WEBPACK FOOTER //
// ./src/lib/index.ts